// @ts-strict-ignore
/**
 * @fileoverview translated department names for display
 */

import type { I18nT } from "@lib/dashboardI18n";
import sharedConstants from "@lib/shared_constants";

import useI18nNamespace from "@services/useI18nNamespace";

const { DEPARTMENTS } = sharedConstants;

// This is getting cloned here for the time being.
// Additions/Subtractions should be caught by the build step if not kept in sync
const departments: {
  [department in keyof typeof DEPARTMENTS]: (t: I18nT<"shared-constants-departments">) => string;
} = {
  agency: (t: I18nT<"shared-constants-departments">) => t("agency", "Agency / Third Party"),
  bi: (t: I18nT<"shared-constants-departments">) => t("bi", "BI / Analytics"),
  "c-suite": (t: I18nT<"shared-constants-departments">) => t("c-suite", "C-Suite"),
  engineering: (t: I18nT<"shared-constants-departments">) => t("engineering", "Engineering"),
  finance: (t: I18nT<"shared-constants-departments">) => t("finance", "Finance"),
  marketing: (t: I18nT<"shared-constants-departments">) => t("marketing", "Marketing / Editorial"),
  pm: (t: I18nT<"shared-constants-departments">) => t("pm", "Product Management"),
};

const useDepartments = (): Array<{ label: string; value: keyof typeof DEPARTMENTS }> => {
  const { t } = useI18nNamespace("shared-constants-departments");

  // { role: value, ... } -> [ { value: role, label: value }, ... ], sorted by the value
  return Object.keys(DEPARTMENTS)
    .map((role: keyof typeof DEPARTMENTS) => ({ value: role, label: departments[role](t) }))
    .sort((a, b) => a.label.localeCompare(b.label));
};

export default useDepartments;
